module.exports = __webpack_public_path__ + "static/img/facebook.c9c3edf4.svg";